import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import bg from "../../assets/images/bg.png";
import { InsuranceList } from "../../constants/index";

const Insurance = ({
	title = "Tenemos el seguro que necesitas",
	type,
	current = "",
}) => {
	return (
		<Wrapper>
			<div
				className={type === "persons" ? "container-fluid" : "container"}
				style={
					type === "persons"
						? { margin: "0 auto" }
						: { width: "90%", margin: "0 auto" }
				}>
				<div className='row'>
					<div className='col-md-12'>
						<h1 className='text-center'>{title}</h1>
					</div>
				</div>
				<div className='row justify-content-center'>
					{InsuranceList[type]
						?.sort((a, b) => a?.key - b?.key)
						?.map(
							(list) =>
								list.key !== current && (
									<div
										key={list.key}
										className={`col-sm-12 col-md-${
											type === "persons" ? 4 : 4
										}`}>
										<div className='card'>
											<div className='card-header'>{list.title}</div>
											<div className='card-body'>
												<img src={list.img} alt={list.title} />
												
												<Link
													to={list?.path || "#"}
													className='btn btn-warning'>
													<span>
														Cotizar
													</span>
												</Link>
											</div>
										</div>
									</div>
								),
						)}
				</div>
			</div>
		</Wrapper>
	);
};

export default Insurance;


export const Wrapper = styled.section`
	padding: 80px 0;
	position: relative;
	background-image: url(${bg});
	height: 100%;
	width: 100%;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;

	@media (min-width: 1200px) {
		.col-lg-3 {
			flex: 0 0 20%;
			max-width: 20%;
		}
	}

	@media (max-width: 767px) {
		padding: 50px 0;
	}

	h1 {
		color: #5268c2;
		font-size: 45px;
		font-weight: 600;

		@media (max-width: 767px) {
			font-size: 30px;
		}
	}

	.card {
		border-radius: 35px;
		box-shadow: 5px 5px 10px #00000029;
		border: none;
		margin-top: 30px;

		.card-header {
			border-radius: 35px 35px 0px 0px;
			background: #5268c2;
			color: #fff;
			text-align: center;
			font-size: 16px;
			font-weight: 600;
			line-height: 21px;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 14px 25px;
			min-height: 72px;
		}

		.card-body {
			text-align: center;
			padding: 15px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				// @media (min-width: 576px) {
				// 	height: 100px;
				// }
			}
		}
		p {
			margin-top: 15px;
			color: #5268c2;
			font-size: 14px;
			margin-bottom: 0;
		}

		.btn {
			margin-top: 15px;
			width: 55%;
			@media (min-width: 576px) {
				width: 90%;
			}
		}
	}
`;
